export default __webpack_public_path__ + "static/media/bloodfrenzy.7cbc6b65.png";